import React, { useState } from 'react';
import AcademicAnalytics from '../components/Analytics/AcademicAnalytics';
import TermAnalytics from '../components/Analytics/TermAnalytics';
// import SupportAnalytics from '../components/Analytics/SupportAnalytics';
import { useAuth } from '../contexts/AuthContext';
import { useData } from '../contexts/DataContext';
import styled from 'styled-components';
import PublicFooter from '../components/Layout/PublicFooter';

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: ${props => props.theme.background};
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${props => props.padding};
  flex-shrink: 0;
  background: ${props => props.theme.backgroundSecondary};

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`;

const Title = styled.h2`
  color: ${props => props.theme.text};
  margin: 0;
  font-weight: 600;
  font-size: ${props => props.compact ? '1rem' : '1.5rem'};
`;

const HeaderActions = styled.div`
  display: flex;
  gap: 0.25rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-end;
  }
`;

const ToggleButton = styled.button`
  background: ${props => props.active ? props.theme.buttonPrimary : props.theme.background};
  border: 1px solid ${props => props.theme.border};
  border-radius: 4px;
  color: ${props => props.theme.text};
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${props => props.active ? props.theme.buttonPrimary : props.theme.cardBackgroundHover};
  }
`;

const Content = styled.div`
  flex: 1;
  overflow: auto;
  padding: ${props => props.padding};
  background: ${props => props.theme.background};
`;

const Analytics = () => {
  const { user } = useAuth();
  const { settings } = useData();
  const [activeTab, setActiveTab] = useState('academic'); // 'academic', 'term', or 'support'

  const isPremium = (user?.subscription && user?.subscription !== 'free') || (user?.aiTier && user?.aiTier !== 'free');
  const isCompact = isPremium && settings?.display?.compactMode;
  const padding = isCompact ? '0.125rem' : '0.75rem';

  return (
    <Container>
      <Header padding={padding}>
        <Title compact={isCompact}>Analytics</Title>
        <HeaderActions>
          <ToggleButton active={activeTab === 'academic'} onClick={() => setActiveTab('academic')}>
            Academic Analytics
          </ToggleButton>
          <ToggleButton active={activeTab === 'term'} onClick={() => setActiveTab('term')}>
            Term Analytics
          </ToggleButton>
          {/* {user?.role === 'admin' && (
            <ToggleButton active={activeTab === 'support'} onClick={() => setActiveTab('support')}>
              Support Analytics
            </ToggleButton>
          )} */}
        </HeaderActions>
      </Header>
      <Content padding={padding}>
        {activeTab === 'academic' && (
          <AcademicAnalytics compact={isCompact} />
        )}
        {activeTab === 'term' && (
          <TermAnalytics compact={isCompact} />
        )}
        {/* {activeTab === 'support' && user?.role === 'admin' && (
          <SupportAnalytics compact={isCompact} />
        )} */}
      </Content>
      <PublicFooter />
    </Container>
  );
};

export default Analytics;